import React from "react";

interface DemoSidebarProps {
  explanation: string;
  currentStage: number;
  totalStages: number;
  completedHighlights?: string[];
}

export const DemoSidebar: React.FC<DemoSidebarProps> = ({
  explanation,
  currentStage,
  totalStages,
  completedHighlights = [],
}) => {
  // Calculate progress percentage
  const progressPercentage = (currentStage / totalStages) * 100;

  return (
    <div className="demo-sidebar">
      <div className="demo-sidebar__header">
        <div className="demo-sidebar__progress-container">
          <div className="demo-sidebar__progress-text">
            Step {currentStage} of {totalStages}
          </div>
          <div className="demo-sidebar__progress-bar">
            <div
              className="demo-sidebar__progress-fill"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>
      </div>

      <div className="demo-sidebar__content">
        <p className="demo-sidebar__explanation">{explanation}</p>

        {completedHighlights.length > 0 && (
          <div className="demo-sidebar__highlights">
            <h3 className="demo-sidebar__highlights-title">Key Features:</h3>
            <ul className="demo-sidebar__highlights-list">
              {completedHighlights.map((highlight, index) => (
                <li key={index} className="demo-sidebar__highlight-item">
                  <span className="demo-sidebar__highlight-check">✓</span>
                  <span className="demo-sidebar__highlight-text">{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className="demo-sidebar__footer">
        <div className="demo-sidebar__footer-text">
          After the tour, you'll set up your personal preferences.
        </div>
      </div>
    </div>
  );
};
